import { Plus } from 'lucide-react'

// Static decorative mock of the native checkout flow. Not interactive.
export default function CheckoutPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="flex items-center justify-between border-b border-black/5 px-5 py-3">
        <span className="text-sm font-semibold">Checkout</span>
        <span className="text-xs text-muted-foreground">Step 1 of 2</span>
      </div>
      <div className="space-y-3 p-5">
        <div className="flex items-center justify-between rounded-xl bg-muted/40 px-4 py-3">
          <div>
            <p className="text-sm font-medium">General Admission</p>
            <p className="text-xs text-muted-foreground">Qty 1</p>
          </div>
          <span className="text-sm font-semibold tabular-nums">$150</span>
        </div>
        <div className="flex items-center justify-between rounded-xl bg-muted/40 px-4 py-3">
          <div>
            <p className="text-sm font-medium">Patron Table (10)</p>
            <p className="text-xs text-muted-foreground">Qty 1</p>
          </div>
          <span className="text-sm font-semibold tabular-nums">$1,500</span>
        </div>
        <div className="flex items-center justify-between rounded-xl border border-dashed border-primary/30 px-4 py-3">
          <span className="flex items-center gap-2 text-sm font-medium text-primary">
            <Plus className="size-3.5" />
            Add a donation
          </span>
          <span className="text-xs text-muted-foreground">Any amount</span>
        </div>
        <div className="flex items-center justify-between border-t border-black/5 pt-3">
          <span className="text-sm font-medium">Total</span>
          <span className="text-lg font-semibold tabular-nums">$1,650.00</span>
        </div>
        <div className="flex h-10 items-center justify-center rounded-lg bg-primary text-sm font-semibold text-primary-foreground">
          Continue to payment
        </div>
      </div>
    </div>
  )
}
